import { render, staticRenderFns } from "./VaccineInventoryPage.vue?vue&type=template&id=7351585a&"
import script from "./VaccineInventoryPage.vue?vue&type=script&lang=js&"
export * from "./VaccineInventoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7351585a')) {
      api.createRecord('7351585a', component.options)
    } else {
      api.reload('7351585a', component.options)
    }
    module.hot.accept("./VaccineInventoryPage.vue?vue&type=template&id=7351585a&", function () {
      api.rerender('7351585a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineInventoryPage/VaccineInventoryPage.vue"
export default component.exports